import { withAuthenticationRequired } from "@auth0/auth0-react";
import Loader from "../../components/Loader";
import styles from "./inspection.module.css";
import Footer from "../../components/Footer";
import { Helmet } from "react-helmet";
import { useState } from "react";
import { Checkbox, FormControl, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { ArrowRight, ArrowUp, Calendar, Filter, Search, Send } from "react-feather";
import { Link } from "react-router-dom";
import { DateRangePicker } from "rsuite";

const Inspections = () => {
    const [loading, setLoading] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);

    return (<>
        {loading && <Loader />}
        <Helmet title="Inspections" />

        <div className={`${styles.mainCard}`}>

            <div className={`${styles.pageTitleWrap}`}>
                <Typography display="inline" className={`${styles.pageTitle}`}>
                    Inspections
                </Typography>
                <p className={`${styles.PageSubTitle}`}>Review and manage inspection data captured with Meta Glasses</p>
            </div>

            <div className={`${styles.CenterBlockSec}`}>
                <div className={`${styles.Row}`}>

                    <div className={`${styles.CashFlowSec}`}>
                        <div className={`${styles.CashFlowRow}`}>
                            <div className={`${styles.CashFlowCard}`}>
                                <img src="/static/img/inspection-icon-1.svg" alt="" />
                                <div className={`${styles.CashFlowCardHead}`}>
                                    <p className={`${styles.CardHeadTitle}`}>Inspections Due Today</p>
                                    <p className={`${styles.CardHeadAmount}`}>48</p>
                                    <p className={`${styles.CardHeadStatus} ${styles.Yellow}`}><span><ArrowUp /> 2</span> from yesterday</p>
                                </div>
                            </div>
                            <div className={`${styles.CashFlowCard}`}>
                                <img src="/static/img/success-img.svg" alt="" />
                                <div className={`${styles.CashFlowCardHead}`}>
                                    <p className={`${styles.CardHeadTitle}`}>Completed This Week</p>
                                    <p className={`${styles.CardHeadAmount}`}>29</p>
                                    <p className={`${styles.CardHeadStatus} ${styles.Green}`}><span><ArrowUp /> 25%</span> from last week</p>
                                </div>
                            </div>
                            <div className={`${styles.CashFlowCard}`}>
                                <img src="/static/img/inspection-icon-3.svg" alt="" />
                                <div className={`${styles.CashFlowCardHead}`}>
                                    <p className={`${styles.CardHeadTitle}`}>Issues Found</p>
                                    <p className={`${styles.CardHeadAmount}`}>14</p>
                                    <p className={`${styles.CardHeadStatus} ${styles.Red}`}><span><ArrowUp /> 15%</span> from last week</p>
                                </div>
                            </div>
                            <div className={`${styles.CashFlowCard}`}>
                                <img src="/static/img/inspection-icon-4.svg" alt="" />
                                <div className={`${styles.CashFlowCardHead}`}>
                                    <p className={`${styles.CardHeadTitle}`}>Work Orders Created</p>
                                    <p className={`${styles.CardHeadAmount}`}>5</p>
                                    <p className={`${styles.CardHeadStatus} ${styles.Green}`}><span><ArrowUp /> 12%</span> from last week</p>
                                </div>
                            </div>
                            <div className={`${styles.CashFlowCard}`}>
                                <img src="/static/img/inspection-icon-5.svg" alt="" />
                                <div className={`${styles.CashFlowCardHead}`}>
                                    <p className={`${styles.CardHeadTitle}`}>Awaiting Review</p>
                                    <p className={`${styles.CardHeadAmount}`}>10</p>
                                    <p className={`${styles.CardHeadStatus} ${styles.Yellow} ${styles.Reverse}`}><span><ArrowUp /> 1</span> from yesterday</p>
                                </div>
                            </div>
                        </div>

                        <div className={`${styles.OfferListSec}`}>
                            <div className={`${styles.CashFlowCard}`}>
                                <div className={`${styles.OfferCardHead}`}>
                                    <div className={`${styles.OfferCardHeadTopSec}`}>
                                        <p className={`${styles.CardHeadTitle}`}>Inspections <span>28 results</span></p>
                                        <Link className={`${styles.AddNoteBu}`}>
                                            <Send /> <span>Schedule Inspection</span>
                                        </Link>
                                    </div>
                                    <div className={`${styles.SearchFilterSec}`}>
                                        <div className={`${styles.SearchCon}`}>
                                            <div className={`${styles.SearchConSec}`}>
                                                <Search />
                                                <input type="text" placeholder="Search" />
                                            </div>
                                        </div>

                                        <div className={`${styles.FilterSec}`}>
                                            <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                                                <p className={`${styles.FilterTitle}`}>
                                                    Filters
                                                    <span>
                                                        <ArrowRight />
                                                    </span>
                                                </p>
                                                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter`}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">
                                                            Property
                                                        </InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            label="Property"
                                                        >
                                                            <MenuItem value="allproperty">
                                                                All Property
                                                            </MenuItem>
                                                            <MenuItem value="WH">The Weston Hall</MenuItem>
                                                            <MenuItem value="EOS">EOS Apartment</MenuItem>
                                                            <MenuItem value="SA">The Smile Apartment</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width150} CusSelectFilter Filter`}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">
                                                            Status
                                                        </InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            label="Status"
                                                        >
                                                            <MenuItem value="allproperty">
                                                                All Status
                                                            </MenuItem>
                                                            <MenuItem value="sent">Sent</MenuItem>
                                                            <MenuItem value="reserved">Reserved</MenuItem>
                                                            <MenuItem value="seheduled">Seheduled</MenuItem>
                                                            <MenuItem value="complete">Complete</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width150} CusSelectFilter Filter`}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">
                                                            Inspector
                                                        </InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            label="Inspector"
                                                        >
                                                            <MenuItem value="allprospect">
                                                                All Inspector
                                                            </MenuItem>
                                                            <MenuItem value="inspector1">John Doe</MenuItem>
                                                            <MenuItem value="inspector2">Merry Joshef</MenuItem>
                                                            <MenuItem value="inspector3">Mark William</MenuItem>
                                                            <MenuItem value="inspector4">Dani Marks</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                                <div className={`${styles.FilterCard}`}>
                                                    <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
                                                        <DateRangePicker
                                                            format={"M/d/yy"}
                                                            placeholder={"Filter by date"}
                                                            placement={"bottomEnd"}
                                                            caretAs={Calendar}
                                                            showOneCalendar
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <Link className={`${styles.FilterBu}`}>
                                                <Filter />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.OfferTableSec}`}>
                                    <TableContainer className={`${styles.TableDiv} CustomTableDiv`}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 220 }}>Tenant</TableCell>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 180 }}>Property</TableCell>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 100 }}>Unit</TableCell>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Scheduled</TableCell>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Completed</TableCell>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Inspector</TableCell>
                                                    <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Status</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell className={`${styles.TableBodyText} ${styles.Head} ${styles.Hover}`}>
                                                        <Checkbox />
                                                        <div className={`${styles.ProfileImg}`}><img src="/static/img/avatars/avatar-4.jpg" alt="" /></div>
                                                        <div className={`${styles.TenantSec}`}>
                                                            <span>Glenda Orlando</span>
                                                            <p>(227) 406-5214</p>
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        The Weston Hall
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        Unit 102
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        April 30, 2026
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        -
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        James Robert
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        <span className={`${styles.StatusBadge} ${styles.Yellow}`}>Scheduled</span>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell className={`${styles.TableBodyText} ${styles.Head} ${styles.Hover}`}>
                                                        <Checkbox />
                                                        <div className={`${styles.ProfileImg}`}><img src="/static/img/avatars/avatar-4.jpg" alt="" /></div>
                                                        <div className={`${styles.TenantSec}`}>
                                                            <span>Glenda Orlando</span>
                                                            <p>(227) 406-5214</p>
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        The Weston Hall
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        Unit 102
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        -
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        -
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        -
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        <span className={`${styles.StatusBadge} ${styles.Blue}`}>Sent</span>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell className={`${styles.TableBodyText} ${styles.Head} ${styles.Hover}`}>
                                                        <Checkbox />
                                                        <div className={`${styles.ProfileImg}`}><img src="/static/img/avatars/avatar-3.jpg" alt="" /></div>
                                                        <div className={`${styles.TenantSec}`}>
                                                            <span>Keith Lane</span>
                                                            <p>(227) 406-5214</p>
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        The Weston Hall
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        Unit 102
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        April 30, 2026
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        -
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        -
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        <span className={`${styles.StatusBadge} ${styles.Purple}`}>Reserved</span>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell className={`${styles.TableBodyText} ${styles.Head} ${styles.Hover}`}>
                                                        <Checkbox />
                                                        <div className={`${styles.ProfileImg}`}><img src="/static/img/avatars/avatar-2.jpg" alt="" /></div>
                                                        <div className={`${styles.TenantSec}`}>
                                                            <span>Nick Anderson</span>
                                                            <p>(227) 406-5214</p>
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        The Weston Hall
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        Unit 102
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        April 30, 2026
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        April 30, 2026
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        John Doe
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        <span className={`${styles.StatusBadge} ${styles.Green}`}>Completed</span>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell className={`${styles.TableBodyText} ${styles.Head} ${styles.Hover}`}>
                                                        <Checkbox />
                                                        <div className={`${styles.ProfileImg}`}><img src="/static/img/avatars/avatar-4.jpg" alt="" /></div>
                                                        <div className={`${styles.TenantSec}`}>
                                                            <span>Glenda Orlando</span>
                                                            <p>(227) 406-5214</p>
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        The Weston Hall
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        Unit 102
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        -
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        -
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        -
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        <span className={`${styles.StatusBadge} ${styles.Blue}`}>Sent</span>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <Footer />
    </>);
};

export default withAuthenticationRequired(Inspections, {
    onRedirecting: () => <Loader />,
});